module.exports = __webpack_public_path__ + "static/media/HM3.6bc9c2ab.png";